import React from 'react';
import { Box, Typography } from '@mui/material';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';

export default function SimpleLoader({ size = 34, title, ...props }) {
  return (
    <Box
      sx={{
        position: 'relative',
        height: size,
        marginTop: '2px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
      data-testid="testSimpleLoader"
    >
      <Box sx={{ position: 'relative', width: size, height: size }}>
        <CircularProgress
          variant="determinate"
          sx={{ color: 'var(--hm-border)' }}
          size={size}
          thickness={3}
          {...props}
          value={100}
        />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={{
            color: '#52bbab',
            animationDuration: '1500ms',
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
          }}
          size={size}
          thickness={3}
          {...props}
        />
      </Box>
      {title && (
        <Typography
          variant="caption"
          sx={{ marginLeft: '8px', color: (theme) => theme.palette.text.secondary }}
        >
          {title}
        </Typography>
      )}
    </Box>
  );
}
